/**
 * v-reveal —— 元素滚动进入视口时的「淡入 + 上移」动效
 *
 * 用法：
 *   <div v-reveal>…</div>            默认 0ms 延迟
 *   <div v-reveal="120">…</div>      延迟 120ms（列表错峰用）
 *
 * 说明：
 *   1. 类名只在指令挂载时添加，因此禁用 JS / 首屏渲染失败时内容照常可见；
 *   2. 尊重 prefers-reduced-motion: reduce，用户关闭系统动效时直接显示；
 *   3. 元素进入视口播放一次后立即停止监听，长页面滚动不产生额外开销。
 */
const ITEM_CLASS = 'reveal-item'
const VISIBLE_CLASS = 'is-revealed'

const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches

const observers = new WeakMap()

export default {
  mounted(el, binding) {
    const delay = Number(binding.value) || 0

    if (prefersReducedMotion() || typeof IntersectionObserver === 'undefined') {
      el.classList.add(ITEM_CLASS, VISIBLE_CLASS)
      return
    }

    el.classList.add(ITEM_CLASS)
    if (delay > 0) el.style.transitionDelay = `${delay}ms`

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          el.classList.add(VISIBLE_CLASS)
          observer.unobserve(el)
          observers.delete(el)
        })
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
    )

    observers.set(el, observer)
    observer.observe(el)
  },

  unmounted(el) {
    const observer = observers.get(el)
    if (!observer) return
    observer.disconnect()
    observers.delete(el)
  }
}
